import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/OccupationSelectModal/logics/createOccupationDisplayData';
import { WorkingPlaceEnvironment } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY } from 'constants/searchCondition';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 会社・職場の環境の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @param param.jobCountData 求人件数
 * @returns 会社・職場の環境の初期配列
 */
export const createInitialWorkplaceEnvironment = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
  jobCountData,
}: HooksArgument) => {
  const paramList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialList: WorkingPlaceEnvironment[] = [
    {
      id: OP_SEARCH_ITEMS.listedCompany.id,
      name: OP_SEARCH_ITEMS.listedCompany.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.listedCompany.id
      ),
      value: WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.LISTED_COMPANY.code,
      jobCount: findJobCount(
        jobCountData.workplaceEnvironmentList,
        WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.LISTED_COMPANY.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.foreignCompany.id,
      name: OP_SEARCH_ITEMS.foreignCompany.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.foreignCompany.id
      ),
      value: WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.FOREIGN_COMPANY.code,
      jobCount: findJobCount(
        jobCountData.workplaceEnvironmentList,
        WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.FOREIGN_COMPANY.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.fewerRetirees.id,
      name: OP_SEARCH_ITEMS.fewerRetirees.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.fewerRetirees.id
      ),
      value: WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.FEWER_RETIREES.code,
      jobCount: findJobCount(
        jobCountData.workplaceEnvironmentList,
        WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.FEWER_RETIREES.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.femaleThriving.id,
      name: OP_SEARCH_ITEMS.femaleThriving.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.femaleThriving.id
      ),
      value: WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.FEMALE_THRIVING.code,
      jobCount: findJobCount(
        jobCountData.workplaceEnvironmentList,
        WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.FEMALE_THRIVING.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.commutingByCar.id,
      name: OP_SEARCH_ITEMS.commutingByCar.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.commutingByCar.id
      ),
      value: WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.COMMUTING_BY_CAR.code,
      jobCount: findJobCount(
        jobCountData.workplaceEnvironmentList,
        WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.COMMUTING_BY_CAR.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.freeDressCode.id,
      name: OP_SEARCH_ITEMS.freeDressCode.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.freeDressCode.id
      ),
      value: WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.FREE_DRESS_CODE.code,
      jobCount: findJobCount(
        jobCountData.workplaceEnvironmentList,
        WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY.FREE_DRESS_CODE.code
      ),
    },
  ];

  return initialList;
};
